
































































































































































import { Action, Getter } from 'vuex-class';
import {
  Component, Model, Prop, PropSync, Vue, Watch,
} from 'vue-property-decorator';
import SignUp2Template from '@/modules/auth/components/templates/SignUp2Template/index.vue';
import { SignUpForm } from '@/modules/auth/types/SignUpForm';
import AuthActionTypes from '@/modules/auth/AuthActionTypes';
import ButtonRoute from '@/components/organisms/ButtonRoute/index.vue';
import SocialAuth from '@/components/organisms/SocialAuth/index.vue';
import SocialProfile from '@/modules/auth/components/SocialProfile.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import DpButton from '@/components/atoms/DpButton/index.vue';
import DpCheckbox from '@/components/atoms/DpCheckbox/index.vue';
import DpInput from '@/components/atoms/DpInput/index.vue';
import ApplicationActionTypes from '@/modules/application/ApplicationActionTypes';
import DpLink from '@/components/atoms/DpLink/index.vue';

@Component({
  name: 'SignUp',
  components: {
    SocialAuth,
    SignUp2Template,
    ButtonRoute,
    SocialProfile,
    SvgIcon,
    DpButton,
    DpCheckbox,
    DpInput,
    DpLink,
  },
})
export default class SignUp2 extends Vue {
  @Action(ApplicationActionTypes.PUSH_ROUTE, { namespace: 'application' })
  protected dispatchPushRoute!: any;

  @Getter('isAuthenticated', { namespace: 'auth' }) protected isAuthenticated?: boolean;

  @Prop({ default: false }) protected isUnlockAllInsights!: boolean;

  @Action(AuthActionTypes.SIGNUP, { namespace: 'auth' }) protected dispatchSignup: any;

  @Action('SET_GOOGLE_USER_DATA', { namespace: 'auth' }) protected dispatchSetGoogleUserData: any;

  @Action('SET_FACEBOOK_USER_DATA', { namespace: 'auth' }) protected dispatchSetFacebookUserData: any;

  @Action('RESET_SIGNUP_FORM', { namespace: 'auth' }) protected dispatchResetSignUpForm: any;

  @Getter('sending', { namespace: 'auth' }) protected sending?: boolean;

  @Getter('signUpForm', { namespace: 'auth' }) protected signUpForm?: SignUpForm;

  @Getter('googleUserData', { namespace: 'auth' }) protected googleUserData?: boolean;

  @Getter('facebookUserData', { namespace: 'auth' }) protected facebookUserData?: boolean;

  @Getter('isSocialProviderSending', { namespace: 'auth' }) protected isSocialProviderSending?: boolean;

  @Action('CONFIRMED_LOGIN', { namespace: 'auth' }) protected dispatchConfirmedLogin: any;

  @Action(ApplicationActionTypes.PRERENDER_READY, { namespace: 'application' })
  protected dispatchPrerenderReady!: any;

  protected goPasswordRecovery() {
    const router: any = {
      name: 'passwordRecovery',
    };
    if (this.signUpForm && this.signUpForm.email && this.signUpForm.email.length) {
      router.params = {
        email: this.signUpForm.email,
      };
    }
    this.dispatchPushRoute(router);
  }

  protected get isEmailExists() {
    return this.signUpForm
      && this.signUpForm.errors
      && this.signUpForm.errors.email
      && this.signUpForm.errors.email
        .findIndex((item: string) => item === 'The email has already been taken.') !== -1;
  }

  protected get loading() {
    return this.isAuthenticated || this.sending;
  }

  protected get title() {
    return this.isUnlockAllInsights ? 'Unlock All Insights' : 'Create Account';
  }

  protected onSignUp() {
    let { signUpForm } = this;
    if (signUpForm) {
      const { plan } = this.$route.query;
      if (plan) {
        signUpForm.subscriptionPlan = (plan as string);
      }
      if (this.$cookies.isKey('referralCode')) {
        signUpForm = {
          referralCode: this.$cookies.get('referralCode'),
          ...signUpForm,
        };
      }
      this.dispatchSignup(signUpForm);
    }
  }

  protected onSocialSignUp(provider:string) {
    this.dispatchConfirmedLogin(provider);
  }

  protected isFormFilled() {
    return this.signUpForm && this.signUpForm.email && this.signUpForm.password;
  }

  @Watch('signUpForm.password')
  protected onSignUpFormPassword() {
    if (this.signUpForm && this.signUpForm.errors) {
      this.signUpForm.errors.password = [];
    }
  }

  @Watch('signUpForm.email')
  protected onSignUpFormEmail() {
    if (this.signUpForm && this.signUpForm.errors) {
      this.signUpForm.errors.email = [];
    }
  }

  @Watch('isAuthenticated', { immediate: true })
  protected watchIsAuthenticated() {
    if (this.isAuthenticated) {
      this.dispatchPushRoute({ name: 'listings' });
    }
  }

  protected mounted(): void {
    this.dispatchPrerenderReady();
    this.dispatchSetGoogleUserData(null);
    this.dispatchSetFacebookUserData(null);
    this.dispatchResetSignUpForm();
    this.onResize();
    (window as any).onResize = () => {
      this.onResize();
    };
  }

  protected onResize() {
    if (this.isUnlockAllInsights) {
      if (window.matchMedia('(max-width: 960px)').matches) {
        window.scrollTo(0, 0);
      }
    }
  }
}

